export enum ESortDirection {
  Asc = "asc",
  Desc = "desc",
}

export enum EFileType {
  Image,
}
